import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons } from "deskera-ui-library";
import { PAGE_ELEMENT, PAGE_TYPE } from "./ComponentList";
import ic_image from "../../assets/canvas/ic_image.png";
import ic_play from "../../assets/icons/ic_play.png";
import ic_image_text from "../../assets/canvas/ic_image_text.png";
import ic_link from "../../assets/canvas/ic_link.png";
import ic_button from "../../assets/canvas/ic_button.png";
import ic_code from "../../assets/canvas/ic_code.png";

/*
PROPS
- onAdd
- pageType (PAGE_TYPE)
*/

class ElementList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewType: this.props.viewType,
    };
  }

  render() {
    const buttonClass = "mt-r listPickerBG";
    return (
      <div
        className={
          "columns bg-white border-radius-s border-box " + this.props.className
        }
      >
        <DKLabel text="+ Add Element" className="fw-m mb-m" />
        <DKButton
          title="Text"
          icon={DKIcons.ic_textfield}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.TEXT)}
          className={buttonClass}
        />
        {this.props.pageType !== PAGE_TYPE.FORM && (
          <DKButton
            title="Button"
            className={buttonClass}
            icon={ic_button}
            onClick={() => this.props.onAdd(PAGE_ELEMENT.BUTTON)}
          />
        )}
        <DKButton
          title="Image"
          className={buttonClass}
          icon={ic_image}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.IMAGE)}
        />
        <DKButton
          title="Video"
          className={buttonClass}
          icon={ic_play}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.VIDEO)}
        />
        <DKButton
          title="Logo / Icon"
          className={buttonClass}
          icon={DKIcons.ic_product}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.ICON)}
        />
        <DKButton
          title="Collection / Gallery"
          className={buttonClass}
          icon={DKIcons.ic_dashboard}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.COLLECTION)}
        />
        <DKButton
          title="Image & Text"
          className={buttonClass}
          icon={ic_image_text}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.IMAGE_TEXT)}
        />
        {(this.props.pageType === PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE ||
          this.props.pageType === PAGE_TYPE.FORM ||
          this.props.pageType === PAGE_TYPE.FUNNEL) && (
          <DKButton
            title="Form"
            className={buttonClass}
            icon={DKIcons.data_type.ic_multi_select}
            onClick={() => this.props.onAdd(PAGE_ELEMENT.FORM)}
          />
        )}
        <DKButton
          title="Social links"
          className={buttonClass}
          icon={ic_link}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.SOCIAL_BUTTONS)}
        />
        <DKButton
          title="Custom HTML"
          className={buttonClass}
          icon={ic_code}
          onClick={() => this.props.onAdd(PAGE_ELEMENT.CUSTOM_HTML)}
        />
      </div>
    );
  }
}

export default ElementList;
